module.exports = __webpack_public_path__ + "media/stylesheets/images/staff_2-b0db4a28178fa378df5ed932f6027f34.jpg";